import { Component, inject, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'fol-img',
  templateUrl: './img.component.html',
  styleUrls: ['./img.component.scss']
})
export class ImgComponent {
  @Input() src = '';
  @Input() title = '';

  private domSanitizer: DomSanitizer = inject(DomSanitizer);

  replaceSrc(): void {
    this.src = (this.domSanitizer.sanitize(SecurityContext.URL, '/assets/img/no-image-found.png') || '').toString();
  }
}
